import { render, staticRenderFns } from "./EInfiniteLoading.vue?vue&type=template&id=4fddd970"
import script from "./EInfiniteLoading.vue?vue&type=script&lang=js"
export * from "./EInfiniteLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports